import GetUrls from 'ts/enums/Url'
import { ButtonStyle } from 'ts/types'
import { Card, Error as ErrorMessage, IconButton, SearchInput } from 'components/ui'
import { ChangeEvent } from 'react'
import { AddIcon } from 'components/svg'
import Modal from 'components/Modal'
import useFetch from 'hooks/useFetch'
import useModalStore from 'store/modal'
import Table from './buttonStyle/Table'
import ButtonStyleAddPage from './ButtonStyleAddPage'

const ButtonStylePage = () => {
  const Url = GetUrls();
  const key = Url.getButtonStyle.toString()
  const { isLoading, error, data } = useFetch<ButtonStyle>(
    key,
    Url.getButtonStyle
  )

  const openModal = useModalStore((state) => state.openModal)
  const handleInputChange = (_e: ChangeEvent<HTMLInputElement>) => {
    // const { value } = _e.currentTarget
    // table.setGlobalFilter(value || undefined)
  }

  return (
    <>
      <div className="p-4">
        {error ? (
          <div className="flex">
            <ErrorMessage data={error} />
          </div>
        ) : null}

        <Card className="flex flex-col">
          <div className="flex">
            <SearchInput onChange={handleInputChange} />

            <IconButton
              aria-label="add"
              title="add"
              isLoading={isLoading}
              onClick={() => openModal(undefined)}
              className="bg-indigo-500"
            >
              <AddIcon />
            </IconButton>
          </div>

          <Table data={data} isLoading={isLoading} onItemClick={openModal} />
        </Card>
      </div>

      <Modal>
        <ButtonStyleAddPage />
      </Modal>
    </>
  )
}

export default ButtonStylePage
